import React from 'react';
import client from 'services/apollo-client';
import Breadcrumbs from 'components/canvas/components/top-left-menu/components/breadcrumbs';
import { useQuery } from '@apollo/client';
import { useHistory, useParams } from 'react-router';
import { surfaceHierarchyQuery } from 'graphql/surface/queries/surface-hierarchy';
import {
  BrandLogo,
  BrandNameContainer,
  Container,
} from 'components/canvas/components/top-left-menu/style';
import { RouteParams } from 'types';
import { notEmpty } from 'utils/js';

export default function TopLeftMenu() {
  const { id } = useParams<RouteParams>();
  const history = useHistory();

  const { data, loading } = useQuery<any>(surfaceHierarchyQuery, {
    client,
    fetchPolicy: 'cache-and-network',
    variables: { input: { surface: id } },
  });

  const notFound =
    loading === false && data?.surfaceHierarchy?.success === false;

  const surfaceHierarchy = data?.surfaceHierarchy?.data ?? [];

  const renderBreadcrumbs = notEmpty(surfaceHierarchy);

  React.useEffect(() => {
    notFound && history.replace('/not-found');
  }, [notFound]);

  return (
    <Container>
      <BrandNameContainer>
        <BrandLogo />
      </BrandNameContainer>
      {renderBreadcrumbs && <Breadcrumbs surfaceHierarchy={surfaceHierarchy} />}
    </Container>
  );
}
